import history from '../../history';
import auth0 from 'auth0-js';
import jwt_decode from 'jwt-decode';
import EnvironmentDefs from '../../EnvironmentDefs';
import AbEnvironment from './AbEnvironment';
import SubscriptionOrderCreateMutation from './SubscriptionOrderCreateMutation';
import UserFetch from '../account/UserFetch';
import AccountFetch from '../account/AccountFetch';
import smartlookClient from 'smartlook-client'
//import { reject } from 'promise';

const envDefs = new EnvironmentDefs();
const abEnvironment = new AbEnvironment();
const lastActivityTimeoutMinutes = 75;

export default class Auth {
  tokenRenewalTimeout;
  lastActivityTime = null;

  auth0 = new auth0.WebAuth({
    domain:       envDefs.getAuth0Domain(),
    clientID:     envDefs.getAuth0Client(),
    redirectUri:  envDefs.getAuth0RedirectUri(),
    audience:     envDefs.getAuth0Audience(),
    responseType: 'token id_token',
    scope:        'openid email profile'
  }); 

  constructor() {
      this.login = this.login.bind(this);
      this.logout = this.logout.bind(this);
      this.logoutWithoutRedirect = this.logoutWithoutRedirect.bind(this);
      this.handleAuthentication = this.handleAuthentication.bind(this);
      this.isAuthenticated = this.isAuthenticated.bind(this);
      this.isAuthenticatedReseller = this.isAuthenticatedReseller.bind(this);
      this.isAuthenticatedVendor = this.isAuthenticatedVendor.bind(this);
      this.isAuthenticatedCustomer = this.isAuthenticatedCustomer.bind(this);
      this.isTransferredCustomer = this.isTransferredCustomer.bind(this);
      this.isAuthenticatedAppBind = this.isAuthenticatedAppBind.bind(this);
      this.isUnauthenticatedCustomer = this.isUnauthenticatedCustomer.bind(this);
      this.isVirtualMasquerade = this.isVirtualMasquerade.bind(this);
      this.isAdminUser = this.isAdminUser.bind(this);
      this.isSessionInactive = this.isSessionInactive.bind(this);
      this.checkForSessionInactivation = this.checkForSessionInactivation.bind(this);

      this.scheduleRenewal();
  }

  login() {
    this.auth0.authorize({ prompt: 'login' });
  }

  loginFromRegister(appcode, vendorId, vendorLogo) {
    let jsonLoginHint = {vendorLogo: vendorLogo};
    if (appcode == null) {
      this.auth0.authorize({ prompt: 'login', login_hint: jsonLoginHint});
    } else {
      jsonLoginHint.vendorId = vendorId;
      let rUri = envDefs.getAuth0RedirectUri() + '?app=' + appcode;
      this.auth0.authorize({ prompt: 'login', login_hint: jsonLoginHint, redirectUri: rUri});
    }
  }


  signup(appcode, vendorId, vendorLogo, vendorResellerAccountId, vRaid) {
    let jsonLoginHint = {hint: 'signup', vendorLogo: vendorLogo};
    if (appcode == null) {
      this.auth0.authorize({ prompt: 'login', login_hint: jsonLoginHint});
    } else {
      jsonLoginHint.vendorId = vendorId;
      let rUri = envDefs.getAuth0RedirectUri() + '?app=' + appcode;
      if (vendorResellerAccountId != null) {
        rUri = rUri + '&vraid=' + vendorResellerAccountId;
      }
      this.auth0.authorize({ prompt: 'login', login_hint: jsonLoginHint, redirectUri: rUri});
    }
  }

  signupFromSO(email, companyName, firstName, lastName, vendorId, vendorLogo) {
      //this is from external SO
      let jsonLoginHint = {hint: 'signup', email: email, companyName: companyName, firstName: firstName, lastName: lastName, vendorId: vendorId, vendorLogo: vendorLogo};
      this.auth0.authorize({ prompt: 'login', login_hint: jsonLoginHint});
  }

  changePassword(email, cb) {
    var data = {
      'email': email,
      'connection': 'Username-Password-Authentication'
    }
    this.auth0.changePassword(data, cb);
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        // Clear any masquerade
        // alert('authResult ok');
        this.endMasqueradeInternal();
        this.setSession(authResult, null);
        // history.replace('/home');
      } else if (err) {
        localStorage.removeItem('app_parm');
        localStorage.removeItem('vraid');
        history.replace('/home');
        this.logError(err);
      }
    });
  }
  
  logError(text) {
    //Log error with smartlook, if activated
    if (envDefs.getSmartlookKey()) {
      try {
        window.console.error('Appbind handled');
        smartlookClient.error(text);

      } catch (error) {
        window.console.error('Could not log error to smartlook: ' + error);
      }
    } else {
      window.console.error(text);
    }
  }
  logWarn(text) {
    window.console.warn(text);
  }
  logInfo(text) {
    window.console.info(text);
  }
  logGeneral(text) {
    window.console.log(text);
  }

  
  isAccountSuspended() {
    let accountStatus = abEnvironment.getUserAttribute("a_aStatus");
    if (accountStatus === 1 || accountStatus === "1") {
      return true;
    } else {
      return false;
    }
  }


  setAuthentication(authResult, link) {
    if (authResult && authResult.access_token && authResult.id_token) {
      // Clear any masquerade
      this.endMasqueradeInternal();
      // Set session
      this.setSession(authResult, link);
    }
  }

  processAppParm = (thisPage, accountId, parmValue, vRaid) => {
    return new Promise(function(resolve, reject) {
      let aPjwt = abEnvironment.getPjwt();

      let accountPath = parmValue.substring(0, parmValue.indexOf('~'));
      let pValue = parmValue.substring(parmValue.indexOf('~') + 1);

      // Call server side process for the prospect.
      let payload = {
        operation: "processResellerLanding",
        params: {
          pJwt:        aPjwt,
          pAccountId:  accountId,
          accountPath: accountPath,
          pValue:      pValue,
          extId:       vRaid
        }
      };
  
      return thisPage.callPartnerApi('appbind/generic',
                                    'POST',
                                    payload)
      .then(response => {
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        this.logError(err);
        reject(err);
      });
    });

  }  

  defaultOnboardingSteps = (thisPage, accountId) => {
    return new Promise(function(resolve, reject) {
      let aPjwt = abEnvironment.getPjwt();

      // Call server side process for the prospect.
      let payload = {
        operation: "defaultOnboardingSteps",
        params: {
          pJwt:       aPjwt,
          pAccountId: accountId
        }
      };
  
      return thisPage.callPartnerApi('appbind/generic',
                                    'POST',
                                    payload)
      .then(response => {
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        this.logError(err);
        reject(err);
      });
    });

  }  

  saveSubscriptionOrderJSON(accountId, soJSON) {
    return new Promise((resolve, reject) => {
      SubscriptionOrderCreateMutation.commit(accountId, soJSON)
      .then(socm => {
        localStorage.removeItem('subscriptionOrder');
        resolve(socm);
      })
      .catch(err => {
        reject(err);
      });
    });
  }  

  convertSubscriptionOrder = (thisPage) => {
    
    var userId = abEnvironment.getUserAttribute("u_id");
    let accountId = abEnvironment.getUserAttribute('a_id');

    return new Promise(function(resolve, reject) {
      let aPjwt = abEnvironment.getPjwt();

      // Call server side process JSON order.
      let payload = {
        operation: "convertSubscriptionOrder3",
        params: {
          pJwt:       aPjwt,
          pAccountId: accountId,
          userId:     userId
        }
      };
  
      return thisPage.callPartnerApi('appbind/generic',
                                    'POST',
                                    payload)
    
      .then(response => {
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(err => {
        this.logError(err);
        reject(err);
      });
    });

  }

  /**
   * This method is used to refresh user information in local storage.  This is invoked on login, on start / end masquerade, and
   * in rare cases (e.g. integration changes) where user information should be refreshed.
   * @param {*} who 
   * @returns 
   */
  refreshUser(who, what) {
    return new Promise((resolve, reject) => {
      let theWho = who;
      if (theWho == null) {
        theWho = abEnvironment.getUserAttribute("userName");
      }

      let theWhat = 'all';
      if (what != null) {
        theWhat = what;
      }

      UserFetch.fetch(theWho).toPromise()
      .then(uf => {
        if (theWhat === 'all') {
          // Local storage sets - account attributes
          abEnvironment.setUserAttribute("a_parentId", uf.userTByUserName.accountTByAccountId.parentId);
          abEnvironment.setUserAttribute("u_email", uf.userTByUserName.email);
          abEnvironment.setUserAttribute("a_accountName", uf.userTByUserName.accountTByAccountId.accountName);
          abEnvironment.setUserAttribute("u_userRole", uf.userTByUserName.userRole); // Construct not widely used

          let firstName = uf.userTByUserName.firstName;
          abEnvironment.setUserAttribute("u_firstName", firstName);
          let lastName = uf.userTByUserName.lastName;
          abEnvironment.setUserAttribute("u_lastName", lastName);

          let inits = "";
          inits += firstName.charAt(0);
          inits += lastName.charAt(0);
          abEnvironment.setUserAttribute("u_inits", inits);

          //set an attribute if the user is part of a transfered customer
          if (uf.userTByUserName.accountTByAccountId.accountType === 4 && uf.userTByUserName.accountTByAccountId.customerStatus === 2) {
            abEnvironment.setUserAttribute("a_customerTransfered", true);
          } else {
            abEnvironment.setUserAttribute("a_customerTransfered", false);
          }

          // Other user attributes
          abEnvironment.setUserAttribute("u_phone",      uf.userTByUserName.phone);
          abEnvironment.setUserAttribute("u_address1",   uf.userTByUserName.address1);
          abEnvironment.setUserAttribute("u_address2",   uf.userTByUserName.address2);
          abEnvironment.setUserAttribute("u_city",       uf.userTByUserName.city);
          abEnvironment.setUserAttribute("u_state",      uf.userTByUserName.state);
          abEnvironment.setUserAttribute("u_country",    uf.userTByUserName.country);
          abEnvironment.setUserAttribute("u_postalCode", uf.userTByUserName.postalCode);
          abEnvironment.setUserAttribute("u_auth0Uid",   uf.userTByUserName.auth0Uid);
          abEnvironment.setUserAttribute("u_userCDate",  uf.userTByUserName.userConfirmDate);
          abEnvironment.setUserAttribute("u_termsDate",  uf.userTByUserName.termsAcceptDate);

          // Other account attributes
          abEnvironment.setUserAttribute("a_aStatus",    uf.userTByUserName.accountTByAccountId.accountStatus);
          abEnvironment.setUserAttribute("a_aType",      uf.userTByUserName.accountTByAccountId.accountType);
          abEnvironment.setUserAttribute("a_description", uf.userTByUserName.accountTByAccountId.description);
          abEnvironment.setUserAttribute("a_lastName",   uf.userTByUserName.accountTByAccountId.contactLastName);
          abEnvironment.setUserAttribute("a_firstName",  uf.userTByUserName.accountTByAccountId.contactFirstName);
          abEnvironment.setUserAttribute("a_email",      uf.userTByUserName.accountTByAccountId.contactEmail);
          abEnvironment.setUserAttribute("a_phone",      uf.userTByUserName.accountTByAccountId.contactPhone);
          abEnvironment.setUserAttribute("a_address1",   uf.userTByUserName.accountTByAccountId.address1);
          abEnvironment.setUserAttribute("a_address2",   uf.userTByUserName.accountTByAccountId.address2);
          abEnvironment.setUserAttribute("a_city",       uf.userTByUserName.accountTByAccountId.city);
          abEnvironment.setUserAttribute("a_state",      uf.userTByUserName.accountTByAccountId.state);
          abEnvironment.setUserAttribute("a_country",    uf.userTByUserName.accountTByAccountId.country);
          abEnvironment.setUserAttribute("a_postalCode", uf.userTByUserName.accountTByAccountId.postalCode);
          abEnvironment.setUserAttribute("a_accountCDate", uf.userTByUserName.accountTByAccountId.accountConfirmDate);
          abEnvironment.setUserAttribute("a_achCDate",    uf.userTByUserName.accountTByAccountId.achConfirmDate);
          abEnvironment.setUserAttribute("a_dwollaCid",   uf.userTByUserName.accountTByAccountId.dwollaCid);
          abEnvironment.setUserAttribute("a_stripeCid",   uf.userTByUserName.accountTByAccountId.stripeCid);
          abEnvironment.setUserAttribute("a_hsId",       uf.userTByUserName.accountTByAccountId.hubspotId);
          abEnvironment.setUserAttribute("a_achActive",   uf.userTByUserName.accountTByAccountId.achActive);
          abEnvironment.setUserAttribute("a_ldId",       uf.userTByUserName.accountTByAccountId.leaddynoId);
          abEnvironment.setUserAttribute("a_ldEmail",    uf.userTByUserName.accountTByAccountId.leaddynoEmail);
          abEnvironment.setUserAttribute("a_useBudgets", uf.userTByUserName.accountTByAccountId.useBudgets);
          abEnvironment.setUserAttribute("a_personaStatus", uf.userTByUserName.accountTByAccountId.personaStatus);
        }

        if (theWhat === 'all' || theWhat === 'integrations') {
          // If there are active integrations, indicate this
          let theKeys = "";
          if (uf.userTByUserName.accountTByAccountId.accountDelegatedAuthsTsByAccountId.totalCount > 0) {
            let theIntegrations = uf.userTByUserName.accountTByAccountId.accountDelegatedAuthsTsByAccountId.nodes;
            for (let i=0; i<theIntegrations.length; i++)
            {
              if (i>0) {
                theKeys = theKeys + ",";
              }
              theKeys = theKeys + theIntegrations[i].appName;
            }
          }
          abEnvironment.setUserAttribute("a_integrations", theKeys);
        }

        if (theWhat === 'all') {
          // Resolve feature flags.
          // Use the account specific flag settings.  Then, if there are any settings that are
          // not account specific and that aren't set at the account level, add them to the list.
          let theFlagJson = null;
          abEnvironment.setUserAttribute("a_flags", '');

          // Account specific flags
          if (uf.userTByUserName.accountTByAccountId.accountFeatureTsByAccountId.totalCount > 0) {
            // Note - this is a deep copy, as we'll be potentially modifying this object.
            theFlagJson = JSON.parse(JSON.stringify(uf.userTByUserName.accountTByAccountId.accountFeatureTsByAccountId));
          }

          // Next, supplement with generic flags.  We only want to add a generic when that value
          // isn't there yet.  So iterate through each of the generic flags.  For each one, then see if the account
          // already has that flag.  If it does, don't add the generic.
          if (uf.allAccountFeatureTs.totalCount > 0) {
            if (theFlagJson == null) {
              // Here, we don't need to do a deep copy as all flags will be generic
              theFlagJson = uf.allAccountFeatureTs;
            } else {
              let flagsToAdd = [];
              for (let i=0; i<uf.allAccountFeatureTs.totalCount; i++) {
                let ffa = uf.allAccountFeatureTs.nodes[i]; // A generic flag
                let addThisFlag = true;
                for (let j=0; j<theFlagJson.totalCount; j++) {
                  let ffg = theFlagJson.nodes[j];
                  if (ffa.flagName === ffg.flagName) {
                    // It already is there, so don't add it.
                    addThisFlag = false;
                    break;
                  }
                }
                if (addThisFlag === true) {
                  flagsToAdd.push(ffa);
                }
              }

              if (flagsToAdd.length > 0) {
                theFlagJson.nodes.push(...flagsToAdd);
              }

              theFlagJson.totalLength = theFlagJson.nodes.length;
            }
          }

          if (theFlagJson != null) {
            let flagString = JSON.stringify(theFlagJson);
            abEnvironment.setUserAttribute("a_flags", flagString);
          }

          // Indicate if payment sources are configured
          let activeSourceCount = 0;
          if (uf.userTByUserName.accountTByAccountId.paymentSourceTsByAccountId.totalCount > 0)
          {
            let psources = uf.userTByUserName.accountTByAccountId.paymentSourceTsByAccountId;
            for (let i=0; i<psources.totalCount; i++)
            {
              //must be active and not be (defunct) Paypal or Payment Rails as those are payout only.
              if (psources.nodes[i].psStatus === 0 && psources.nodes[i].psType !== 2 && psources.nodes[i].psType !== 3) {
                activeSourceCount++;
              }
            }
          }
          abEnvironment.setUserAttribute("ps_count",   activeSourceCount);
          abEnvironment.setUserAttribute("cust_count", uf.userTByUserName.accountTByAccountId.accountTsByParentId.totalCount);
          abEnvironment.setUserAttribute("subs_count", uf.userTByUserName.accountTByAccountId.bindCardTsByProvisioningAccountId.totalCount);

          //if marqeta sees this, it will not pop up a dialog warning user about clipboard
          let date = new Date();
          date.setDate(date.getDate() + 85);  //85 days out.
          abEnvironment.setUserAttribute("clipboardWarning", date);
        }

        resolve(1);
      })
      .catch(err => {
        this.logError('Error in user lookup: ' + err);
        reject(err);
      });
    });
  }

  /**
   * Wrap leaddyno call in a promise
   */
  recordLeadDynoLead(theEmail, leadData) {
    return new Promise((resolve, reject) => {
      try {
        window.LeadDyno.recordLead(theEmail, leadData, (success) => {
          resolve(success);
        });
      } catch (anError) {
        // Error recording lead
        this.logError('LeadDyno lead recording error: ' + anError);
        resolve(null);
      }
    });
  }

  asyncToActiveCampaign(accountId) {
    let payload = {
      operation: "asyncLinkAccountToActiveCampaign",
      params: {
        accountId: accountId
      }
    };

    Promise.resolve()
    .then(() => {
      return this.callPartnerApi('appbind/generic', 'POST', payload);
    })
    .catch(err => {
      return null;
    });
  }

  /**
   * Called when a session is established when a user logs in, or when a token is
   * renewed.
   */
  setSession(authResult, link, fromRenewToken) {
    // Depending on how the auth object was sourced (what Auth0 api was used), the
    // object attributes are named differently.  Handle this here.
    let expiresAt;
    if (authResult.idTokenPayload != null && authResult.idTokenPayload.exp != null) {
      expiresAt = JSON.stringify(authResult.idTokenPayload.exp * 1000);
    } else {
      let authExpiresIn = authResult.expiresIn;
      if (authExpiresIn == null) {
        authExpiresIn = authResult.expires_in;
      }
      expiresAt = JSON.stringify((authExpiresIn * 1000) + new Date().getTime());
    }

    localStorage.setItem('expires_at', expiresAt);

    let authAccessToken = authResult.accessToken;
    if (authAccessToken == null) {
      authAccessToken = authResult.access_token;
    }
    localStorage.setItem('access_token', authAccessToken);

    let authIdToken = authResult.idToken;
    if (authIdToken == null) {
      authIdToken = authResult.id_token;
    }
    localStorage.setItem('id_token', authIdToken);

    // Set the time that the access token will expire at
    this.scheduleRenewal();

    // Set additional metadata context from the id_token; also represented
    // on the user table, but use the id_token since it is there...
    let decoded = jwt_decode(authIdToken);
    let u_id = decoded["https://ns.appbind.com/u_id"];
    let a_id = decoded["https://ns.appbind.com/a_id"];
    let role = decoded["https://ns.appbind.com/role"];
    let mfa = decoded["https://ns.appbind.com/mfa"];
    let exp = decoded["exp"];

    let expMillis = Number(exp) * 1000;

    // Request a token for db access
    let loadMetrics = false;
    let app_parm;
    let vraid;

    let aEmail;
    let hasPendingSubscriptionOrder = false;
    let stepperResumeLink = '';
    let thisPage = this;

    Promise.resolve()
    .then(() => {
      return this.callPartnerApi('appbind/pgauth',
                                 'POST',
                                 {
                                   'aid': a_id,
                                   'uid': u_id,
                                   'role': role,
                                   'exp': expMillis
                                 });
    })
    .then((resp) => {
      return resp.json();
    })
    .then((jresp) => {
      let pjwt = jresp.pjwt;

      //temporaryCode
      let verification = jresp.verification;
      let verificationAuto = jresp.verificationAuto;

      if (!verification || verification === 'false') {
        localStorage.setItem("verification", '0');
      } else {
        localStorage.setItem("verification", '1');
      }

      if (!verificationAuto || verificationAuto === 'false') {
        localStorage.setItem("verificationAuto", '0');
      } else {
        localStorage.setItem("verificationAuto", '1');
      }

      let userName = null;
      userName = decoded["https://ns.appbind.com/username"];
      if (userName == null)
      {
        let email = decoded["email"];
        userName = email.replace('@', '-').toLowerCase();
        // userName = decoded["name"];
      }

      let email_verified = decoded["https://ns.appbind.com/email_verified"];

      localStorage.setItem("u_id", u_id);
      localStorage.setItem("a_id", a_id);
      localStorage.setItem("role", role);
      localStorage.setItem("mfa", mfa);
      localStorage.setItem("pjwt", pjwt);
      localStorage.setItem("userName", userName);
      if (email_verified === true || this.isUnauthenticatedCustomer()) {
        localStorage.setItem("email_verified", "true");
      } else {
        localStorage.setItem("email_verified", "false");
      } 

      // Metrics gathering.  Only load once, and not if in masquerade
      // - If m_userName is not null, this is an admin is masquerading as a user.  
      //   We don't want to track that.
      let m_userName = localStorage.getItem("m_userName");
      if (m_userName == null)
      {
        // email won't be in local storage the first time in - only want to load
        // metrics once.
        let uEmail = localStorage.getItem("u_email");
        if (uEmail == null)
        {
          loadMetrics = true;
        }
      }

      app_parm = localStorage.getItem('app_parm');
      if (app_parm != null) {
        localStorage.removeItem('app_parm');
      }
      vraid = localStorage.getItem('vraid');
      if (vraid != null) {
        localStorage.removeItem('vraid');
      }

      // Now load user info
      return this.refreshUser(userName, 'all');
    })
    .then(resp => {    
      var subscriptionOrderJSONString = localStorage.getItem('subscriptionOrder');
      if (subscriptionOrderJSONString != null) {
        var soJSON = JSON.parse(subscriptionOrderJSONString);
        hasPendingSubscriptionOrder = true;
        return this.saveSubscriptionOrderJSON(a_id, soJSON);
      } else {
        return null;
      }
    })
    .then(resp => {    
      if (hasPendingSubscriptionOrder === true) {
        //if user has a pending subscription order and their email is verified, it means
        //they are an existing user who logged in instead of signed up.
        if (abEnvironment.getUserAttribute('email_verified') === 'true') {
          return this.convertSubscriptionOrder(thisPage);
        }
      } else {
        return null;
      }
    })
    .then((resp) => {
      if (resp && resp.data && resp.data.result  && resp.data.result.data && hasPendingSubscriptionOrder) {
        //The user is sent to SO
        localStorage.setItem('subscriptionOrderComplete', true);
        stepperResumeLink = '/subscriptionorder';
      }
      return null;
    })
    /* ActiveCampaign integration in process */
    .then(resp => {
        // Sync account to active campaign if assent has already been given.  This check should only be done
        // once, so don't if metrics have already been loaded.
        let theAccountType = localStorage.getItem("a_aType");
        if (loadMetrics && ! this.needAssent() && theAccountType === '3') {
          return this.asyncToActiveCampaign(a_id);
        } else {
          return null;
        }
    })
    .then(resp => {
      aEmail = localStorage.getItem("a_email");
      let firstName = localStorage.getItem("u_firstName");
      let lastName = localStorage.getItem("u_lastName");
      let companyName = localStorage.getItem("a_accountName");

      let uMail = localStorage.getItem("u_email");
      let fullName = firstName + " " + lastName;
      let userID = localStorage.getItem("u_id");
 
      if (loadMetrics)
      {
        // Identify user with smartlook, if activated
        if (envDefs.getSmartlookKey()) {
          try {
            smartlookClient.identify(userID, {
              name: fullName,
              email: uMail
            });  
          } catch (error) {
            this.logError('Problem trying to identify to smartlook: ' + error);
          } 
        }

        // Identify userpilot user
        try {
          if (window.userpilot) {
            window.userpilot.identify( 
              userID, // Used to identify users 
              { 
                name: fullName, // Full name 
                email: uMail, // Email address 
                created_at: new Date(), // Signup date as a Unix timestamp 
                appbind_role: role
                  // Additional user properties 
                  // createdProject: "true",
                  // projectId: "1"
              } , 1    
            );
          }
        } catch (error) {
          this.logError('User pilot identify error: ' + error);
        }

        // Identify user with segment
        if (envDefs.isSegmentActive()) {
          window.analytics.identify(userID, {
            name: fullName,
            email: uMail
          });

          window.analytics.track('Account Logged In');
        }

        // Identify user with LeadDyno
        if (envDefs.isLeadDynoActive()) {
          // Only set as lead if the account hasn't been set yet
          let aType = localStorage.getItem("a_aType");
          if (localStorage.getItem("a_ldId") == null && (aType === '1' || aType === '2' || aType === '3')) {
            return this.recordLeadDynoLead(aEmail,
                                           {first_name: firstName,
                                            last_name: lastName,
                                            company: companyName
                                            });
          }
        }

        return null;
      }
    })
    .then(resp => {
      if (resp == null) {
        return null;
      }

      // Set
      let payload = {
        operation: "leadRecorded",
        params: {
          accountEmail: aEmail
        }
      };
      
      return this.callPartnerApi('appbind/generic',
                                 'POST',
                                 payload);
    })
    .then(resp => {    
      if (resp != null) {
        return resp.json();
      }
      return null;
    })
    .then(jresp => {    
      if (jresp != null && jresp.leaddynoId) {
        abEnvironment.setUserAttribute("a_ldId",    jresp.leaddynoId);
        abEnvironment.setUserAttribute("a_ldEmail", jresp.leaddynoEmail);
      }

      if (app_parm != null) {
        return this.processAppParm(thisPage, a_id, app_parm, vraid);
      } else {
        //call the logic to default the onboarding steps.  For signup and landing, it happens elsewhere (processAppParm and ConvertSubscriptionOrder3)
        if ((abEnvironment.getUserAttribute('email_verified') !== 'true') && !hasPendingSubscriptionOrder) {
          return this.defaultOnboardingSteps(thisPage, a_id);
        } else {
          return null;
        }
      }
    })
    .then(resp => {
      if (fromRenewToken) {
        //don't do anything since this renewing is a background operation
      } else if (app_parm != null) {
        //user is coming from the landing page.  Take the reseller to the appropriate partner program unless the account path was appbind - this is special.
        //we do this by taking the result of the processResellerProspect and putting in a local storage variable.  Then we go to home which prompts them to check their
        //email.  The Verify logic will look at this storage variable and redirect them.
        //
        //The response from above has a structure like this.  If we cannot find that structure OR success is not achieved, just go to home
        //{"abMessage":"Success in processResellerProspect: Success","err":null,"data":{"status":0,"message":"Success","vppId":"af0375fa-bc1e-11ec-82f4-4b71465262ec"}}
        if (resp.data && resp.data.message === "Success" && resp.data.appbind) {
          //do not redirect to vpp page
          history.replace('/home');
        } else if (resp.data && resp.data.message === "Success") {
          //put a local storage item so verify takes them to here.
          let vppLink = '/vendorpartnerprogram?vppId=' + resp.data.vppId;
          if (localStorage.getItem('email_verified') === 'true') {
            history.replace(vppLink); //reseller already existing, take them there.
          } else {
            localStorage.setItem('fromVendorLanding', vppLink);
            history.replace('/home');  //here they will get the verify email page
          }
        } else {
          history.replace('/home');  
        }
 
      } else {
        if (link) {
          history.replace(link);
          if (link.startsWith('/stepperresumecustomer') || link.startsWith('/steppercustomerauthorize') || link.startsWith('/authonlyauthorize')) {
            //2023-06-14 removed this.  It was causing problems were the component was starting to load with the replace(link) and then
            //started again.  In some cases this caused the previous query to be cancelled which threw an exception.  This caused Auth.js to log off
            //in the catch block below.  This made every subsquent query failed due to no id_token.  The original purpose of the below was to 'eject' the user
            //out of the menu.  Commenting this out seems to still work.
            //window.location.reload();
          }
        } else {
          if (hasPendingSubscriptionOrder) {
            if (stepperResumeLink !== '') {
              history.replace(stepperResumeLink);  
              window.location.reload();
            } else if (abEnvironment.getUserAttribute('email_verified') !== 'true') {
              //if the user is not email verified, send them
              history.replace('/steppersigninemail?accountId=' + a_id);  
              window.location.reload();
            } else {
              if (localStorage.getItem('redirectAfterLogin') !== null) {
                let newRoute = localStorage.getItem('redirectAfterLogin');
                localStorage.removeItem('redirectAfterLogin');
                history.replace(newRoute);
              } else {
                history.replace('/home');  
              }
            }
          } else {
            if (localStorage.getItem('redirectAfterLogin') !== null) {
              let newRoute = localStorage.getItem('redirectAfterLogin');
              localStorage.removeItem('redirectAfterLogin');
              history.replace(newRoute);
            } else {
              history.replace('/home');  
            }
          }
        }
      }

    })
    .catch(err => {
      this.logError('Exception in auth.js: ' + err);
      if (this.isAuthenticated()) {
        // Logout current user - this will get rid of the nav bar (otherwise it flashes)
        this.logoutWithoutRedirect();
      }
      history.replace('/systemdown');
      window.location.reload();
    });
  }

  isMasquerade () {
    let mrole = localStorage.getItem("m_role");
    if (mrole != null)
        return true;
    else
        return false;
  }

  isVirtualMasquerade() {
    if (this.isMasquerade()) {
      let theMasqueradeUid = localStorage.getItem('m_u_id');
      let theUid           = localStorage.getItem('u_id');

      if (theUid === theMasqueradeUid) {
        return true;
      }
    }
    return false;
  }

  masqueradeAs(u_id, a_id, role, userName) {
    localStorage.setItem("m_u_id", u_id);
    localStorage.setItem("m_a_id", a_id);
    localStorage.setItem("m_role", role);

    // masquerade pjwt
    let id_token = localStorage.getItem('id_token');
    let decoded = jwt_decode(id_token);
    let exp = decoded["exp"];

    let expMillis = Number(exp) * 1000;

    Promise.resolve()
    .then(() => {
      return this.callPartnerApi('appbind/pgauth',
                                 'POST',
                                 {
                                   'aid': a_id,
                                   'uid': u_id,
                                   'role': role,
                                   'exp': expMillis
                                 });
    })
    .then((resp) => {
      return resp.json();
    })
    .then((jresp) => {
      let mpjwt = jresp.pjwt;
      localStorage.setItem("m_pjwt", mpjwt);
      localStorage.setItem("m_userName", userName);
      localStorage.setItem("m_email_verified", 'true'); // Not exactly correct, but ok
      return this.refreshUser(userName, 'all');
    })
    .then(resp => {
      // navigate to the home route
      history.replace('/home');
    })
    .catch(err => {
      // navigate to the home route
      history.replace('/home');
    });
  }

  /* This method is only used for Vendors where we want to do setup for them prior 
  to setting up users.  Do not use for any other purpose. */
  masqueradeAsCurrentUser(u_id, a_id, role, userName) {
    localStorage.setItem("m_u_id", u_id);
    localStorage.setItem("m_a_id", a_id);
    localStorage.setItem("m_role", role);

    // masquerade pjwt
    let id_token = localStorage.getItem('id_token');
    let decoded = jwt_decode(id_token);
    let exp = decoded["exp"];

    let expMillis = Number(exp) * 1000;

    Promise.resolve()
    .then(() => {
      return this.callPartnerApi('appbind/pgauth',
                                 'POST',
                                 {
                                   'aid': a_id,
                                   'uid': u_id,
                                   'role': role,
                                   'exp': expMillis
                                 });
    })
    .then((resp) => {
      return resp.json();
    })
    .then((jresp) => {
      let mpjwt = jresp.pjwt;
      localStorage.setItem("m_pjwt", mpjwt);
      localStorage.setItem("m_userName", userName);
      localStorage.setItem("m_email_verified", 'true'); // Not exactly correct, but ok

      // Use the current user information?  Or make something up?
      abEnvironment.setUserAttribute("u_email",      localStorage.getItem("u_email"));
      abEnvironment.setUserAttribute("u_userRole",   localStorage.getItem("u_userRole"));
      abEnvironment.setUserAttribute("u_firstName",  localStorage.getItem("u_firstName"));
      abEnvironment.setUserAttribute("u_lastName",   localStorage.getItem("u_lastName"));
      abEnvironment.setUserAttribute("u_inits",      localStorage.getItem("u_inits"));
      abEnvironment.setUserAttribute("u_phone",      localStorage.getItem("u_phone"));
      abEnvironment.setUserAttribute("u_address1",   localStorage.getItem("u_address1"));
      abEnvironment.setUserAttribute("u_address2",   localStorage.getItem("u_address2"));
      abEnvironment.setUserAttribute("u_city",       localStorage.getItem("u_city"));
      abEnvironment.setUserAttribute("u_state",      localStorage.getItem("u_state"));
      abEnvironment.setUserAttribute("u_country",    localStorage.getItem("u_country"));
      abEnvironment.setUserAttribute("u_postalCode", localStorage.getItem("u_postalCode"));
      abEnvironment.setUserAttribute("u_auth0Uid",   localStorage.getItem("u_auth0Uid"));
      abEnvironment.setUserAttribute("u_userCDate",  localStorage.getItem("u_userCDate"));
      abEnvironment.setUserAttribute("u_termsDate",  localStorage.getItem("u_termsDate"));

      // Use the masquerading account's confirmation date
      abEnvironment.setUserAttribute("a_accountCDate", localStorage.getItem("a_accountCDate"));

      //set an attribute if the user is part of a transfered customer
      abEnvironment.setUserAttribute("a_customerTransfered",  localStorage.getItem("a_customerTransfered"));

      // Set account values that won't be set from the masquerading account
      abEnvironment.setUserAttribute("a_lastName",     'Virtual');
      abEnvironment.setUserAttribute("a_firstName",    'Virtual');
      abEnvironment.setUserAttribute("a_email",        localStorage.getItem("a_email"));
      abEnvironment.setUserAttribute("a_phone",        '');
      abEnvironment.setUserAttribute("a_address1",     '123 Main St');
      abEnvironment.setUserAttribute("a_address2",     '');
      abEnvironment.setUserAttribute("a_city",         'City');
      abEnvironment.setUserAttribute("a_state",        'CA');
      abEnvironment.setUserAttribute("a_country",      'USA');
      abEnvironment.setUserAttribute("a_postalCode",   '99999');
      abEnvironment.setUserAttribute("a_achCDate",     '');
      abEnvironment.setUserAttribute("a_dwollaCid",    '');
      abEnvironment.setUserAttribute("a_stripeCid",    '');
      abEnvironment.setUserAttribute("a_hsId",         '');
      abEnvironment.setUserAttribute("a_ldId",         '');
      abEnvironment.setUserAttribute("a_ldEmail",      '');
      abEnvironment.setUserAttribute("a_useBudgets",   '1');

      // Fetch the account
      return AccountFetch.fetch(a_id).toPromise();
    })
    .then (af => {
      // af.accountTByAccountId.
      abEnvironment.setUserAttribute("a_parentId",    af.accountTByAccountId.parentId);
      abEnvironment.setUserAttribute("a_accountName", af.accountTByAccountId.accountName);
      abEnvironment.setUserAttribute("a_aStatus",     af.accountTByAccountId.accountStatus);
      abEnvironment.setUserAttribute("a_aType",       af.accountTByAccountId.accountType);
      abEnvironment.setUserAttribute("a_description", af.accountTByAccountId.description);
      abEnvironment.setUserAttribute("a_achActive",   af.accountTByAccountId.achActive);

      //should not do anything with payment sources - add payment method turned off.
      abEnvironment.setUserAttribute("ps_count",   0);
      abEnvironment.setUserAttribute("cust_count", 0);
      abEnvironment.setUserAttribute("subs_count", 0);

      // flags
      if (af.accountTByAccountId.accountFeatureTsByAccountId.totalCount > 0) {
        let flagString = JSON.stringify(af.accountTByAccountId.accountFeatureTsByAccountId);
        abEnvironment.setUserAttribute("a_flags", flagString);
      }

        //add allow customer transfer if needed.  This is temporary
        if (af.accountTByAccountId.accountTByParentId && af.accountTByAccountId.accountTByParentId.accountFeatureTsByAccountId.totalCount > 0 && af.accountTByAccountId.accountType === 4) {

          let i = 0;
          for (i = 0; i < af.accountTByAccountId.accountTByParentId.accountFeatureTsByAccountId.totalCount; i++) {
            let feature = af.accountTByAccountId.accountTByParentId.accountFeatureTsByAccountId.nodes[i];
            if (feature.flagName === "allow_customer_transfer" && feature.flagValue === 1) {
              let existingFlagString = abEnvironment.getUserAttribute('a_flags');
              if (existingFlagString == null || existingFlagString === '') {
                let flagJson = {
                  "totalCount": 1,
                  "nodes": [{
                    "flagName": "allow_customer_transfer",
                    "flagValue": 1,
                    "flagValueTxt": null
                  }]

                };
                let flagString = JSON.stringify(flagJson);
                abEnvironment.setUserAttribute("a_flags", flagString);
              } else {
                
                let flagJson = JSON.parse(existingFlagString);
                 let temp = flagJson;
                temp.nodes.push({
                  "flagName": "allow_customer_transfer",
                  "flagValue": 1,
                  "flagValueTxt": null
                })
                temp.totalCount = temp.totalCount + 1;
                let flagString = JSON.stringify(temp);
                abEnvironment.setUserAttribute("a_flags", flagString);
              }
            }
          }

        }

      // navigate to the home route
      history.replace('/home');
    })
    .catch(err => {
      localStorage.removeItem("m_u_id");
      localStorage.removeItem("m_a_id");
      localStorage.removeItem("m_role");

      // navigate to the home route
      history.replace('/home');
    });
  }

  endMasqueradeInternal() {
    // Attributes added from JWT token
    localStorage.removeItem("m_pjwt");
    localStorage.removeItem("m_u_id");
    localStorage.removeItem("m_a_id");
    localStorage.removeItem("m_role");
    localStorage.removeItem("m_userName");
    localStorage.removeItem("m_email_verified");

    // User attributes added from query
    localStorage.removeItem('m_u_email');
    localStorage.removeItem('m_u_userRole');
    localStorage.removeItem('m_u_firstName');
    localStorage.removeItem('m_u_lastName');
    localStorage.removeItem('m_u_inits');
    localStorage.removeItem('m_u_phone');
    localStorage.removeItem('m_u_address1');
    localStorage.removeItem('m_u_address2');
    localStorage.removeItem('m_u_city');
    localStorage.removeItem('m_u_state');
    localStorage.removeItem('m_u_country');
    localStorage.removeItem('m_u_postalCode');
    localStorage.removeItem("m_u_auth0Uid");
    localStorage.removeItem('m_u_userCDate');
    localStorage.removeItem('m_u_termsDate');

    // Account attributes added from query
    localStorage.removeItem('m_a_parentId');
    localStorage.removeItem('m_a_accountName');
    localStorage.removeItem('m_a_aStatus');
    localStorage.removeItem('m_a_aType');
    localStorage.removeItem('m_a_description');
    localStorage.removeItem('m_a_firstName');
    localStorage.removeItem('m_a_lastName');
    localStorage.removeItem('m_a_email');
    localStorage.removeItem('m_a_phone');
    localStorage.removeItem('m_a_address1');
    localStorage.removeItem('m_a_address2');
    localStorage.removeItem('m_a_city');
    localStorage.removeItem('m_a_state');
    localStorage.removeItem('m_a_country');
    localStorage.removeItem('m_a_postalCode');
    localStorage.removeItem('m_a_accountCDate');
    localStorage.removeItem('m_a_achCDate');
    localStorage.removeItem('m_a_dwollaCid');
    localStorage.removeItem('m_a_stripeCid');
    localStorage.removeItem('m_a_hsId');
    localStorage.removeItem('m_a_achActive');
    localStorage.removeItem('m_a_ldId');
    localStorage.removeItem('m_a_ldEmail');
    localStorage.removeItem('m_a_useBudgets');
    localStorage.removeItem('m_a_flags');
    localStorage.removeItem('m_a_availableBalance');

    localStorage.removeItem('m_ps_count');
    localStorage.removeItem('m_cust_count');
    localStorage.removeItem('m_subs_count');

    localStorage.removeItem('customerTabVal');
  }

  endMasquerade() {
    this.endMasqueradeInternal();

    let un = localStorage.getItem('userName');
    this.refreshUser(un, 'all')
    .then(resp => {
      // navigate to the home route
      history.replace('/home');
    })
    .catch(err => {
      // navigate to the home route
      history.replace('/home');
    });
  }

  renewToken() {
    this.auth0.checkSession({}, (err, result) => {
      if (err) {
        this.logError(err);
      } else {
        this.setSession(result, null, true);
      }
    });
  }

  scheduleRenewal() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    // console.log("In schedule renewal - expires at is " + expiresAt);
    // delay = token length - time now - 1 minute;
    // in other words if token exires in 1 hour, delay should be 59 minutes.
    let delay = expiresAt - Date.now() - 60000;
    if (expiresAt === null) {
      //someone not logged in.
      delay = 0;
    }
    // console.log("Schedule renewal - expiresAt is " + expiresAt);
    // console.log("Schedule renewal - now is " + Date.now());
    // console.log("Schedule renewal - delay is " + delay);

    if (delay > 43200000) {
      // if delay is greater than 2 hours, it means it is an unathenticated customer.  
      // I picked the above value which means 12 hours.  Authenticated should be between
      // 2 and 24 hours.  If it gets in here, its an unauthenticated customer.  Set time to recheck for 15 minutes
      delay = 900000;
      //delay = 120000;
    }
    // console.log("Schedule renewal - revised delay is " + delay);

    //delay = 60000;
    //delay = 15000;
    if (delay > 0) {
      // console.log("Setup the timeout with delay " + delay);

      clearTimeout(this.tokenRenewalTimeout);
      this.tokenRenewalTimeout = setTimeout(() => {
        
        // console.log("In token renewal logic");
        let theRole = localStorage.getItem("m_role");
        if (theRole == null) {
          theRole = localStorage.getItem('role');
        }
        
        //note this is NOT calling isAuthenticated because that resets the activity time.
        let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        if (expiresAt !== null) {
          if (this.isSessionInactive()) {
            // console.log("Session is inactive.  Logging out");
            this.logout();
          } else {
            if (theRole !== 'appbind_customer_unauth') {
              // console.log("Auth customer - call renew token");
              this.renewToken();
            } else {
              // console.log("Unauth customer - call schedule renewal");
              this.scheduleRenewal();
              //currently unauthenticated customers do now renew.  That is because their token is good for 24 hours.
              //The intersection of someone using their magic link AND being active for 24 hours is almost null.
            }
          }
        } else {
          //user is logged off so not renewing token.  In this case too we no longer schedule a renewal
        }
      }, delay);
    }
  }

  logoutWithoutRedirect() {
    // Clear access token and ID token from local storage
    clearTimeout(this.tokenRenewalTimeout);

    // Remove specific items from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('u_id');
    localStorage.removeItem('a_id');
    localStorage.removeItem('role');
    localStorage.removeItem("mfa");
    localStorage.removeItem("pjwt");
    localStorage.removeItem('userName');
    localStorage.removeItem("email_verified");

    // User attributes added from query
    localStorage.removeItem('u_email');
    localStorage.removeItem('u_userRole');
    localStorage.removeItem('u_firstName');
    localStorage.removeItem('u_lastName');
    localStorage.removeItem('u_inits');
    localStorage.removeItem('u_phone');
    localStorage.removeItem('u_address1');
    localStorage.removeItem('u_address2');
    localStorage.removeItem('u_city');
    localStorage.removeItem('u_state');
    localStorage.removeItem('u_country');
    localStorage.removeItem('u_postalCode');
    localStorage.removeItem("u_auth0Uid");
    localStorage.removeItem('u_userCDate');
    localStorage.removeItem('u_termsDate');

    // Account attributes added from query
    localStorage.removeItem('a_parentId');
    localStorage.removeItem('a_accountName');
    localStorage.removeItem('a_aStatus');
    localStorage.removeItem('a_aType');
    localStorage.removeItem('a_description');
    localStorage.removeItem('a_firstName');
    localStorage.removeItem('a_lastName');
    localStorage.removeItem('a_email');
    localStorage.removeItem('a_phone');
    localStorage.removeItem('a_address1');
    localStorage.removeItem('a_address2');
    localStorage.removeItem('a_city');
    localStorage.removeItem('a_state');
    localStorage.removeItem('a_country');
    localStorage.removeItem('a_postalCode');
    localStorage.removeItem('a_accountCDate');
    localStorage.removeItem('a_achCDate');
    localStorage.removeItem('a_dwollaCid');
    localStorage.removeItem('a_stripeCid');
    localStorage.removeItem('a_hsId');
    localStorage.removeItem('a_achActive');
    localStorage.removeItem('a_ldId');
    localStorage.removeItem('a_ldEmail');
    localStorage.removeItem('a_useBudgets');
    localStorage.removeItem('a_flags');
    localStorage.removeItem('a_availableBalance');

    // PS
    localStorage.removeItem('ps_count');

    // Custs
    localStorage.removeItem('cust_count');
    localStorage.removeItem('subs_count');

    // Masquerade attributes
    localStorage.removeItem("m_u_id");
    localStorage.removeItem("m_a_id");
    localStorage.removeItem("m_role");
    localStorage.removeItem("m_userName");
    localStorage.removeItem("m_pjwt");

    localStorage.removeItem('m_u_email');
    localStorage.removeItem('m_u_userRole');
    localStorage.removeItem('m_u_firstName');
    localStorage.removeItem('m_u_lastName');
    localStorage.removeItem('m_u_inits');
    localStorage.removeItem('m_u_phone');
    localStorage.removeItem('m_u_address1');
    localStorage.removeItem('m_u_address2');
    localStorage.removeItem('m_u_city');
    localStorage.removeItem('m_u_state');
    localStorage.removeItem('m_u_country');
    localStorage.removeItem('m_u_postalCode');
    localStorage.removeItem("m_u_auth0Uid");
    localStorage.removeItem('m_u_userCDate');
    localStorage.removeItem('m_u_termsDate');

    localStorage.removeItem('m_a_parentId');
    localStorage.removeItem('m_a_accountName');
    localStorage.removeItem('m_a_aStatus');
    localStorage.removeItem('m_a_aType');
    localStorage.removeItem('m_a_description');
    localStorage.removeItem('m_a_firstName');
    localStorage.removeItem('m_a_lastName');
    localStorage.removeItem('m_a_email');
    localStorage.removeItem('m_a_phone');
    localStorage.removeItem('m_a_address1');
    localStorage.removeItem('m_a_address2');
    localStorage.removeItem('m_a_city');
    localStorage.removeItem('m_a_state');
    localStorage.removeItem('m_a_country');
    localStorage.removeItem('m_a_postalCode');
    localStorage.removeItem('m_a_accountCDate');
    localStorage.removeItem('m_a_achCDate');
    localStorage.removeItem('m_a_dwollaCid');
    localStorage.removeItem('m_a_stripeCid');
    localStorage.removeItem('m_a_hsId');
    localStorage.removeItem('m_a_achActive');
    localStorage.removeItem('m_a_ldId');
    localStorage.removeItem('m_a_ldEmail');
    localStorage.removeItem('m_a_useBudgets');
    localStorage.removeItem('m_a_flags');
    localStorage.removeItem('m_a_availableBalance');

    localStorage.removeItem('m_ps_count');
    localStorage.removeItem('m_cust_count');
    localStorage.removeItem('m_subs_count');

    localStorage.removeItem('bcIndex');

    // Clear local storage to be sure
    localStorage.clear();
  }

  logout() {
    /*
    // Clear access token and ID token from local storage
    clearTimeout(this.tokenRenewalTimeout);

    // Remove specific items from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('u_id');
    localStorage.removeItem('a_id');
    localStorage.removeItem('role');
    localStorage.removeItem("mfa");
    localStorage.removeItem("pjwt");
    localStorage.removeItem('userName');
    localStorage.removeItem("email_verified");

    // User attributes added from query
    localStorage.removeItem('u_email');
    localStorage.removeItem('u_userRole');
    localStorage.removeItem('u_firstName');
    localStorage.removeItem('u_lastName');
    localStorage.removeItem('u_inits');
    localStorage.removeItem('u_phone');
    localStorage.removeItem('u_address1');
    localStorage.removeItem('u_address2');
    localStorage.removeItem('u_city');
    localStorage.removeItem('u_state');
    localStorage.removeItem('u_country');
    localStorage.removeItem('u_postalCode');
    localStorage.removeItem("u_auth0Uid");
    localStorage.removeItem('u_userCDate');
    localStorage.removeItem('u_termsDate');

    // Account attributes added from query
    localStorage.removeItem('a_parentId');
    localStorage.removeItem('a_accountName');
    localStorage.removeItem('a_aStatus');
    localStorage.removeItem('a_aType');
    localStorage.removeItem('a_description');
    localStorage.removeItem('a_firstName');
    localStorage.removeItem('a_lastName');
    localStorage.removeItem('a_email');
    localStorage.removeItem('a_phone');
    localStorage.removeItem('a_address1');
    localStorage.removeItem('a_address2');
    localStorage.removeItem('a_city');
    localStorage.removeItem('a_state');
    localStorage.removeItem('a_country');
    localStorage.removeItem('a_postalCode');
    localStorage.removeItem('a_accountCDate');
    localStorage.removeItem('a_achCDate');
    localStorage.removeItem('a_dwollaCid');
    localStorage.removeItem('a_stripeCid');
    localStorage.removeItem('a_hsId');
    localStorage.removeItem('a_achActive');
    localStorage.removeItem('a_ldId');
    localStorage.removeItem('a_ldEmail');
    localStorage.removeItem('a_useBudgets');

    // PS
    localStorage.removeItem('ps_count');

    // Custs
    localStorage.removeItem('cust_count');
    localStorage.removeItem('subs_count');

    // Masquerade attributes
    localStorage.removeItem("m_u_id");
    localStorage.removeItem("m_a_id");
    localStorage.removeItem("m_role");
    localStorage.removeItem("m_userName");
    localStorage.removeItem("m_pjwt");

    localStorage.removeItem('m_u_email');
    localStorage.removeItem('m_u_userRole');
    localStorage.removeItem('m_u_firstName');
    localStorage.removeItem('m_u_lastName');
    localStorage.removeItem('m_u_inits');
    localStorage.removeItem('m_u_phone');
    localStorage.removeItem('m_u_address1');
    localStorage.removeItem('m_u_address2');
    localStorage.removeItem('m_u_city');
    localStorage.removeItem('m_u_state');
    localStorage.removeItem('m_u_country');
    localStorage.removeItem('m_u_postalCode');
    localStorage.removeItem("m_u_auth0Uid");
    localStorage.removeItem('m_u_userCDate');
    localStorage.removeItem('m_u_termsDate');

    localStorage.removeItem('m_a_parentId');
    localStorage.removeItem('m_a_accountName');
    localStorage.removeItem('m_a_aStatus');
    localStorage.removeItem('m_a_aType');
    localStorage.removeItem('m_a_description');
    localStorage.removeItem('m_a_firstName');
    localStorage.removeItem('m_a_lastName');
    localStorage.removeItem('m_a_email');
    localStorage.removeItem('m_a_phone');
    localStorage.removeItem('m_a_address1');
    localStorage.removeItem('m_a_address2');
    localStorage.removeItem('m_a_city');
    localStorage.removeItem('m_a_state');
    localStorage.removeItem('m_a_country');
    localStorage.removeItem('m_a_postalCode');
    localStorage.removeItem('m_a_accountCDate');
    localStorage.removeItem('m_a_achCDate');
    localStorage.removeItem('m_a_dwollaCid');
    localStorage.removeItem('m_a_stripeCid');
    localStorage.removeItem('m_a_hsId');
    localStorage.removeItem('m_a_achActive');
    localStorage.removeItem('m_a_ldId');
    localStorage.removeItem('m_a_ldEmail');
    localStorage.removeItem('m_a_useBudgets');

    localStorage.removeItem('m_ps_count');
    localStorage.removeItem('m_cust_count');
    localStorage.removeItem('m_subs_count');

    localStorage.removeItem('bcIndex');

    // Clear local storage to be sure
    localStorage.clear();
    */

    this.logoutWithoutRedirect();

    // navigate to the home route
    // history.replace('/');
    // This approach clears out the memory of history in react router.
    history.entries = [];
    history.index = -1;
    history.push("/");
    window.location.reload();
  }

  needAssent = () => {

    let uacd = abEnvironment.getUserAttribute('a_accountCDate');
    let uucd = abEnvironment.getUserAttribute('u_userCDate');
    let utd  = abEnvironment.getUserAttribute('u_termsDate');
    let needver = false;
    if (abEnvironment.getUserAttribute('email_verified') !== 'true')
      needver = true;

      if (uacd == null || uacd === '' || uucd == null || uucd === '' || 
          utd == null || utd === '' || needver) {
      return true;
    }
    return false;
  }  

  isValidDeepLink(pathName) {
    //is the user is not logged on, there are certain urls we do not want redirected to after login
    if (history.location.pathname === '/') {
      return false;
    }
    if (history.location.pathname === '/home') {
      return false;
    }
    if (history.location.pathname === '/callback') {
      return false;
    }
    if (history.location.pathname === '/appentry') {
      return false;
    }
    if (history.location.pathname.startsWith('/verify')) {
      return false;
    }
    if (history.location.pathname.startsWith('/order')) {
      return false;
    }    
    if (history.location.pathname.startsWith('/partner/')) {
      return false;
    }
    if (history.location.pathname.startsWith('/steppersignin')) {
      return false;
    }    
    if (history.location.pathname.startsWith('/systemdown')) {
      return false;
    }    
    if (history.location.pathname.startsWith('/plaidoa2')) {
      return false;
    }    
    return true;

  }

  isEmailContentAllowed(content) {
    //utility method to validate the various places we allow free form email entry.  We have had bad actors signup. 

    //first we lower case.  Then we replace remove all spaces.  Finally look for things we know are bad.
    let lcHtmlBody = content.toLowerCase();
    lcHtmlBody = lcHtmlBody.replace(/\s+/g, '');

    if (lcHtmlBody.indexOf('<input') !== -1) {
      return false;
    }
    if (lcHtmlBody.indexOf('<a') !== -1) {
      return false;
    }
    if (lcHtmlBody.indexOf('onclick=') !== -1) {
      return false;
    }
    if (lcHtmlBody.indexOf('<script') !== -1) {
      return false;
    }
    return true;

  }


  isAuthenticated() {
    // Check whether the current time is past the 
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    if (expiresAt === null) {

      if (localStorage.getItem('redirectAfterLogin') === null && this.isValidDeepLink(history.location.pathname)) {
        let path = history.location.pathname;
        if (history.location.search) {
          path = path + history.location.search
        }
        //the above prevents /home from overwriting where the user might want to go....
        localStorage.setItem('redirectAfterLogin', path);
      }

      return false;
    }
    
    let theCurrentTime = new Date().getTime();

    let isAuthed = theCurrentTime < expiresAt;
    if (isAuthed) {
      this.lastActivityTime = new Date().getTime();
      // console.log('lastActivityTime set to ' + this.lastActivityTime);

      return true;
    } else {

      if (localStorage.getItem('redirectAfterLogin') === null  && this.isValidDeepLink(history.location.pathname)) {

        let path = history.location.pathname;
        if (history.location.search) {
          path = path + history.location.search
        }
        //the above prevents /home from overwriting where the user might want to go....
        localStorage.setItem('redirectAfterLogin', path);
      }

      return false;
    }
  }

  isSessionInactive() {
    //compute last activity time in minues
    if (this.lastActivityTime) {
      let lastActivityInMinutes = ((new Date().getTime()) - this.lastActivityTime) / 1000 / 60; 
      // console.log('lastActivityInMinutes ' + lastActivityInMinutes);
      if (lastActivityInMinutes > lastActivityTimeoutMinutes) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  checkForSessionInactivation() {
    if (this.isSessionInactive()) {
      // console.log('Check for session inactivation, found expiration, logging out');
      this.logout();
    }
  }
 
  isAuthenticatedAppBind() {
    if (!this.isAuthenticated()) {
      return false;
    }

    let theRole = localStorage.getItem("m_role");
    if (theRole == null) {
      theRole = localStorage.getItem('role');
    }
  
    return theRole === 'appbind_appbind';
  }

  isAuthenticatedReseller() {
    if (!this.isAuthenticated()) {
      return false;
    }

    let theRole = localStorage.getItem("m_role");
    if (theRole == null) {
      theRole = localStorage.getItem('role');
    }
  
    return theRole === 'appbind_reseller';
  }
 
  isAuthenticatedVendor() {
    if (!this.isAuthenticated()) {
      return false;
    }

    let theRole = localStorage.getItem("m_role");
    if (theRole == null) {
      theRole = localStorage.getItem('role');
    }
    
    return theRole === 'appbind_vendor';
  }
 
  isAuthenticatedCustomer() {
    if (!this.isAuthenticated()) {
      return false;
    }

    let theRole = localStorage.getItem("m_role");
    if (theRole == null) {
      theRole = localStorage.getItem('role');
    }
    
    return theRole === 'appbind_customer';
  }
  
  isTransferredCustomer() {
    if (!this.isAuthenticated()) {
      return false;
    }

    let theValue = localStorage.getItem("m_a_customerTransfered");
    if (theValue == null) {
      theValue = localStorage.getItem("a_customerTransfered");
    }
    return ((theValue === true) || (theValue === 'true')) ;
  }

  isUnauthenticatedCustomer() {
    if (!this.isAuthenticated()) {
      return false;
    }

    let theRole = localStorage.getItem("m_role");
    if (theRole == null) {
      theRole = localStorage.getItem('role');
    }
    
    return theRole === 'appbind_customer_unauth';
  }

  isAdminUser() {
    // let uid = abEnvironment.getUserAttribute('u_id');
    let ia = false;
    if (abEnvironment.getUserAttribute('u_userRole') === '0') {
      ia = true;
    }

    return ia;
  }

  getAccountUUID() {
    let theUuid = localStorage.getItem("m_a_id");
    if (theUuid == null) {
      theUuid = localStorage.getItem('a_id');
    }
    return theUuid;
  }

  getSkey() {
    // return "pk_test_ZRvtfkvblKPhOw3D1sosTdhO"; // POC
    // return "pk_live_VDA9McBVyPUOSUTWNjDPQTP5"; // Production
    return envDefs.getSkey();
  }

  getBaseRedirect() {
    return envDefs.getBaseRedirect();
  }

  callPartnerApi(theTarget, theMethod, theBody, skipAuth, contentType) {
    let theUrl = envDefs.getPartnerApiUrl() + theTarget;
    let theContentType = contentType;
    if (contentType == null)
    {
      theContentType = 'application/json';
    }
    else if (contentType === 'multipart/form-data')
    {
      theContentType = null; // form data on the body will be used to set the header
    }

    var theHeaders = {
    };

    let needAuth = true;

    if (skipAuth === true)
    {
      needAuth = false;
    }
    
    if (needAuth)
    {
      theHeaders['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');
    }

    if (theMethod === 'POST' || theMethod === 'PATCH')
    {
      let postBody = theBody; // Body to be posted.  Will be stringified unless this is form data
      if (contentType !== 'multipart/form-data' && theBody != null) {
        //theBody.params.acstat = abEnvironment.getUserAttribute("a_aStatus");
        let aBody = theBody;
        let theStatus = abEnvironment.getUserAttribute("a_aStatus");
        if (theStatus != null) {
          if (aBody.params == null) {
            let theParams = {
              acstat: theStatus
            };
            aBody.params = theParams;
          } else {
            aBody.params['acstat'] = theStatus;
          }
        }
        postBody = JSON.stringify(aBody);
      }

      theHeaders['Accept'] = 'application/json';

      if (theContentType != null)
      {
        theHeaders['Content-Type'] = theContentType;
      }

      return fetch(theUrl, {
        method: theMethod,
        headers: theHeaders,
        body: postBody
      });

      /*
      return new Promise(function(resolve, reject) {
        return fetch(theUrl, {
          method: theMethod,
          headers: theHeaders,
          body: theBody
        });
      })
      .then(response => {
        return 
      })
      .catch(err => {
        reject(err);
      });
      */
    }

    return fetch(theUrl, {
      method: theMethod,
      headers: theHeaders
    });
  }

  validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  getUniquePresentmentIndex() {
    let anIndex = localStorage.getItem('bcIndex');
    if (anIndex == null) {
      anIndex = 0;
    }

    let theIndex = parseInt(anIndex);
    theIndex = theIndex + 1;

    localStorage.setItem('bcIndex', theIndex);

    return theIndex;
  }

  getInitialBalanceAmountLimit() {
    let initialBalanceAmountLimit = 9999;
    let initialBalanceAmountLimitValue= abEnvironment.getFlagValue("initialBalanceAmountLimit");
    if (initialBalanceAmountLimitValue != null && initialBalanceAmountLimitValue.flagValue > 0) {
      initialBalanceAmountLimit = initialBalanceAmountLimitValue.flagValueTxt;
    }
    return Number(initialBalanceAmountLimit);
  }
  getInitialBalanceAmountDefault() {
    let initialBalanceAmountDefault = 500;
    let initialBalanceAmountDefaultValue= abEnvironment.getFlagValue("initialBalanceAmountDefault");
    if (initialBalanceAmountDefaultValue != null && initialBalanceAmountDefaultValue.flagValue > 0) {
      initialBalanceAmountDefault = initialBalanceAmountDefaultValue.flagValueTxt;
    }
    return Number(initialBalanceAmountDefault);
  }
  getInitialBalanceAmountMinimum() {
    let initialBalanceAmountMinimum = 40;
    let initialBalanceAmountMinimumValue= abEnvironment.getFlagValue("initialBalanceAmountMinimum");
    if (initialBalanceAmountMinimumValue != null && initialBalanceAmountMinimumValue.flagValue > 0) {
      initialBalanceAmountMinimum = initialBalanceAmountMinimumValue.flagValueTxt;
    }
    return Number(initialBalanceAmountMinimum);
  }
  getOneTimeBalanceAmountMinimum() {
    let oneTimeBalanceAmountMinimum = 1;
    let oneTimeBalanceAmountMinimumValue= abEnvironment.getFlagValue("oneTimeBalanceAmountMinimum");
    if (oneTimeBalanceAmountMinimumValue != null && oneTimeBalanceAmountMinimumValue.flagValue > 0) {
      oneTimeBalanceAmountMinimum = oneTimeBalanceAmountMinimumValue.flagValueTxt;
    }
    return Number(oneTimeBalanceAmountMinimum);
  }

  getTopupActiveDefault() {
    let topupActiveDefault = 1;
    let topupActiveDefaultValue = abEnvironment.getFlagValue("autoTopupActiveDefault");
    if (topupActiveDefaultValue != null && topupActiveDefaultValue.flagValue > 0) {
      topupActiveDefault = topupActiveDefaultValue.flagValueTxt;
    }
    return Number(topupActiveDefault);
  }

  getTopupTargetLimit() {
    let topupTargetLimit = 9999;
    let topupTargetLimitValue = abEnvironment.getFlagValue("topupTargetLimit");
    if (topupTargetLimitValue != null && topupTargetLimitValue.flagValue > 0) {
      topupTargetLimit = topupTargetLimitValue.flagValueTxt;
    }
    return Number(topupTargetLimit);
  }
  getTopupTargetDefault() {
    let topupTargetDefault = 500;
    let topupTargetDefaultValue = abEnvironment.getFlagValue("topupTargetDefault");
    if (topupTargetDefaultValue != null && topupTargetDefaultValue.flagValue > 0) {
      topupTargetDefault =topupTargetDefaultValue.flagValueTxt;
    }
    return  Number(topupTargetDefault);
  }
  getTopupTargetMinimum() {
    let topupTargetMinimum = 40;
    let topupTargetMinimumValue = abEnvironment.getFlagValue("topupTargetMinimum");
    if (topupTargetMinimumValue != null && topupTargetMinimumValue.flagValue > 0) {
      topupTargetMinimum = topupTargetMinimumValue.flagValueTxt;
    }
    return Number(topupTargetMinimum);
  }

  getTopupThresholdLimit() {
    let topupThresholdLimit = 9999;
    let topupThresholdLimitValue = abEnvironment.getFlagValue("topupThresholdLimit");
    if (topupThresholdLimitValue != null && topupThresholdLimitValue.flagValue > 0) {
      topupThresholdLimit = topupThresholdLimitValue.flagValueTxt;
    }
    return Number(topupThresholdLimit);
  }
  getTopupThresholdDefault() {
    let topupThresholdDefault = 200;
    let topupThresholdDefaultValue = abEnvironment.getFlagValue("topupThresholdDefault");
    if (topupThresholdDefaultValue != null && topupThresholdDefaultValue.flagValue > 0) {
      topupThresholdDefault = topupThresholdDefaultValue.flagValueTxt;
    }
    return Number(topupThresholdDefault);
  }
  getTopupThresholdMinimum() {
    let topupThresholdMinimum = 20;
    let topupThresholdMinimumValue = abEnvironment.getFlagValue("topupThresholdMinimum");
    if (topupThresholdMinimumValue != null && topupThresholdMinimumValue.flagValue > 0) {
      topupThresholdMinimum = topupThresholdMinimumValue.flagValueTxt;
    }
    return Number(topupThresholdMinimum);
  }

  getMaxMonthlyBudgetLimit() {
    let maxMonthlyBudgetLimit = 99999;
    let maxMonthlyBudgetLimitValue = abEnvironment.getFlagValue("maxMonthlyBudgetLimit");
    if (maxMonthlyBudgetLimitValue != null && maxMonthlyBudgetLimitValue.flagValue > 0) {
      maxMonthlyBudgetLimit = maxMonthlyBudgetLimitValue.flagValueTxt;
    }
    return Number(maxMonthlyBudgetLimit);
  }
  getMaxMonthlyBudgetDefault() {
    let maxMonthlyBudgetDefault = 1000;
    let maxMonthlyBudgetDefaultValue = abEnvironment.getFlagValue("maxMonthlyBudgetDefault");
    if (maxMonthlyBudgetDefaultValue != null && maxMonthlyBudgetDefaultValue.flagValue > 0) {
      maxMonthlyBudgetDefault = maxMonthlyBudgetDefaultValue.flagValueTxt;
    }
    return Number(maxMonthlyBudgetDefault);
  }
  getMaxMonthlyBudgetMinimum() {
    let maxMonthlyBudgetMinimum = 100;
    let maxMonthlyBudgetMinimumValue = abEnvironment.getFlagValue("maxMonthlyBudgetMinimum");
    if (maxMonthlyBudgetMinimumValue != null && maxMonthlyBudgetMinimumValue.flagValue > 0) {
      maxMonthlyBudgetMinimum = maxMonthlyBudgetMinimumValue.flagValueTxt;
    }
    return Number(maxMonthlyBudgetMinimum);
  }


  getMaxServiceAmount() {
    let maxServiceAmount = 9999;
    let maxServiceAmountValue = abEnvironment.getFlagValue("maxServiceAmount");
    if (maxServiceAmountValue != null && maxServiceAmountValue.flagValue > 0) {
      maxServiceAmount = maxServiceAmountValue.flagValueTxt;
    }
    return Number(maxServiceAmount);
  }

  getInvoiceTerminology() {
    let invoiceName = 'Bills';
    let invoiceNameValue = abEnvironment.getFlagValue("invoiceName");
    if (invoiceNameValue != null && invoiceNameValue.flagValue === 1) {
      invoiceName = invoiceNameValue.flagValueTxt;
    }
    return invoiceName;
  }

  getBalanceFundingTerminology() {
    let invoiceName = 'Balance funding receipt';
    let invoiceNameValue = abEnvironment.getFlagValue("balanceFundingReceiptName");
    if (invoiceNameValue != null && invoiceNameValue.flagValue === 1) {
      invoiceName = invoiceNameValue.flagValueTxt;
    }
    return invoiceName;
  }

  getDocumentTerm(termkey) {
    let termEntry = abEnvironment.getFlagValue(termkey);
    if (termEntry != null && termEntry.flagValue === 1) {
      return termEntry.flagValueTxt;
    }
    return termkey;
  }

  decryptOneTimeEncryptedValue(keyId, encryptedData, callPartnerApi) {
    return new Promise(function(resolve, reject) {

      // console.log('decryptOneTimeEncryptedValue');
      // Call server side process for the prospect.
      let payload = {
        operation: "getOneTimeKey",
        params: {
          oneTimeKeyId: keyId
        }
      };

      let theSalt;
      let theIv;
      let theCiphertext;

      return callPartnerApi('appbind/generic',
                                    'POST',
                                    payload)
      .then(response => {
        return response.json();
      })
      .then(data => {
        let theKey = data.key.keyValue;
        // console.log('got one time key: ' + theKey);
        if (theKey != null) {
          let enc = new TextEncoder();
          return window.crypto.subtle.importKey('raw', enc.encode(theKey), "PBKDF2", false, ["deriveKey"]);
        } else {
          return null;
        }
      })
      .then(theCryptoKey => {
        if (theCryptoKey != null) {
          // console.log('have a crypto key');
          // Get the buffer info from the base64 string
          let theBuffer = Uint8Array.from(atob(encryptedData), c => c.charCodeAt(null));
          theSalt = theBuffer.slice(0, 16);
          theIv = theBuffer.slice(16, 16 + 12);
          theCiphertext = theBuffer.slice(16 + 12);

          // Derive an AES key
          return window.crypto.subtle.deriveKey(
            {
              name: "PBKDF2",
              salt: theSalt,
              iterations: 250000,
              hash: "SHA-256",
            },
            theCryptoKey,
            { name: "AES-GCM", length: 256 },
            false,
            ["decrypt"]
          );
        } else {
          return null;
        }                
      })
      .then((aesKey) => {
        if (aesKey != null) {
          // console.log('have an aes key');
          return window.crypto.subtle.decrypt(
            {
              name: "AES-GCM",
              iv: theIv,
            },
            aesKey,
            theCiphertext
          );
        } else {
          return null;
        }
      })
      .then((decrypted) => {
        // console.log('decrypted');
        if (decrypted != null) {
          let theDecoder = new TextDecoder();
          let unencrypted = theDecoder.decode(decrypted);
          resolve(unencrypted);
        } else {
          reject('Unable to decrypt');
          return null;
        }
      })
      .catch(err => {
        // console.log('Error decrypting: ' + err);
        //this.logError(err);
        reject(err);
      });
    });    
  }

  encryptOneTimeEncryptedValue(data, callPartnerApi) {
    return new Promise(function(resolve, reject) {
      let theResponse = {
        status: -1,
        message: 'Unidentified error'
      };

      // Get a one-time key.
      let payload = {
        operation: "getOneTimeKey"
      };

      let theKeyId;
      let theSalt;
      let theIv;

      return callPartnerApi('appbind/generic',
                                    'POST',
                                    payload)
      .then(response => {
        return response.json();
      })
      .then(data => {
        theKeyId = data.key.keyId;
        let theKey = data.key.keyValue;
        if (theKey != null) {
          let enc = new TextEncoder();
          return window.crypto.subtle.importKey('raw', enc.encode(theKey), "PBKDF2", false, ["deriveKey"]);
        } else {
          return null;
        }
      })
      .then(theCryptoKey => {
        if (theCryptoKey != null) {
          // Generate salt and iv
          theSalt = window.crypto.getRandomValues(new Uint8Array(16));
          theIv = window.crypto.getRandomValues(new Uint8Array(12));

          // Derive an AES key
          return window.crypto.subtle.deriveKey(
            {
              name: "PBKDF2",
              salt: theSalt,
              iterations: 250000,
              hash: "SHA-256",
            },
            theCryptoKey,
            { name: "AES-GCM", length: 256 },
            false,
            ["encrypt"]
          );
        } else {
          return null;
        }                
      })
      .then((aesKey) => {
        if (aesKey != null) {
          let theEncoder = new TextEncoder();
          let encodedContent = theEncoder.encode(data);

          return window.crypto.subtle.encrypt(
            {
              name: "AES-GCM",
              iv: theIv,
            },
            aesKey,
            encodedContent
          );
        } else {
          return null;
        }
      })
      .then((encrypted) => {
        if (encrypted != null) {
          // Convert to base 64
          const encryptedContentArray = new Uint8Array(encrypted);
          let buff = new Uint8Array(theSalt.byteLength + theIv.byteLength + encryptedContentArray.byteLength);
          buff.set(theSalt, 0);
          buff.set(theIv, theSalt.byteLength);
          buff.set(encryptedContentArray, theSalt.byteLength + theIv.byteLength);
          const base64Buff = btoa(new Uint8Array(buff).reduce((data, byte) => data + String.fromCharCode(byte), ''));

          theResponse.status = 0;
          theResponse.message = 'Success';
          theResponse.keyId = theKeyId;
          theResponse.encryptedData = base64Buff;

          // Resolve
          resolve(theResponse);
        } else {
          theResponse.status = -2;
          theResponse.message = 'Unable to encrypt';
          reject(theResponse);
        }
      })
      .catch(err => {
        theResponse.message = err;
        reject(theResponse);
      });
    });    
  }

}
